/**
 * Analytics constants for Rovo Spaces impact instrumentation.
 *
 * Centralised here so event names / action-subjects don't drift across call
 * sites and are easy to assert in unit tests. See the impact-metrics plan
 * (ROVOFE-2925, Atlas ATLAS-124860).
 *
 * Instrumentation is guarded by the existing `rovo_chat_spaces_experiment`
 * experiment — the same experiment that renders Spaces — inlined at each
 * `FeatureGates.getExperimentValue(...)` call site in `useSpacesAnalytics`.
 */

/**
 * Grouped Spaces analytics vocabulary. A single export keeps event names in one
 * place (one-value-export-per-file) while callers reference stable keys.
 */
export const SPACES_ANALYTICS = {
	/**
	 * `source` value used on AI MAU events so Spaces value-moments are
	 * attributable back to the Spaces surface within Rovo Chat MAU.
	 */
	mauSource: 'rovoSpace',
	/** GASv3 action / actionSubject vocabulary for Spaces track/ui events. */
	events: {
		spaceCreated: { action: 'created', actionSubject: 'rovoSpace' },
		sourceAdded: { action: 'added', actionSubject: 'spaceSource' },
		sourceRemoved: { action: 'removed', actionSubject: 'spaceSource' },
		sourceRecommendationsViewed: { action: 'viewed', actionSubject: 'spaceSourceRecommendations' },
		conversationAdded: { action: 'added', actionSubject: 'spaceConversation' },
		memoryCreated: { action: 'created', actionSubject: 'spaceMemory' },
		memoriesViewed: { action: 'viewed', actionSubject: 'spaceMemory' },
		spaceSearched: { action: 'searched', actionSubject: 'rovoSpace' },
		starterClicked: { action: 'clicked', actionSubject: 'spaceStarter' },
	},
	/** Screen-view event names. */
	screens: {
		spaceLandingPage: 'rovoSpaceLandingPage',
	},
} as const;
